import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import axios from "axios";
import { hostServer } from "../actions/consts/host";
import { startRefresh, startGetMonitorHistory } from "../actions/checks.js";
import * as R from "ramda";
import UptimeTimeline from "./UptimeTimeline";
import UptimeTable from "./UptimeTable";
import ApdexTimeline from "./ApdexTimeline";
import RPTChart from "./RPTChart";
import RTChart from "./RTChart";
import ProbersChart from "./ProbersChart";
import MonthlyHitMap from "./MonthlyHitMap";
import MonitorHeader from "./MonitorHeader";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Loader from "./Loader";
import "../styles/components/check-detail.scss";

class CheckDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      rawData: undefined,
      rawDataChartToggle: false,
    };
  }

  toggle = () => {
    this.setState((prevState) => ({
      toggle: !prevState.toggle,
    }));
  };

  toggleRawData = () => {
    this.setState(
      (prevState) => ({
        rawDataChartToggle: !prevState.rawDataChartToggle,
      }),
      () => {
        if (this.state.rawDataChartToggle) {
          this.getRawData();
        }
      }
    );
  };

  getRawData = async () => {
    const lastCheckAt = this.props.check.data.last_check_at;
    const times = (h) =>
      moment(lastCheckAt).subtract(h, "hours").format("YYYY-MM-DD HH:mm:ss.SS");
    const timingWindow = R.map(times, [0, 6, 12, 18, 24]);
    const id = this.props.check.id;
    const token = this.props.token;

    const json = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const rawData1 = await axios.get(
      `${hostServer}/api/v1/monitors/${id}/metric/raw?from_time=${timingWindow[4]}&to_time=${timingWindow[3]}`,
      json
    );

    const rawData2 = await axios.get(
      `${hostServer}/api/v1/monitors/${id}/metric/raw?from_time=${timingWindow[3]}&to_time=${timingWindow[2]}`,
      json
    );

    const rawData3 = await axios.get(
      `${hostServer}/api/v1/monitors/${id}/metric/raw?from_time=${timingWindow[2]}&to_time=${timingWindow[1]}`,
      json
    );

    const rawData4 = await axios.get(
      `${hostServer}/api/v1/monitors/${id}/metric/raw?from_time=${timingWindow[1]}&to_time=${timingWindow[0]}`,
      json
    );

    const rawDataUnProcessed = R.reduce(
      R.concat,
      [],
      [
        rawData1.data.result,
        rawData2.data.result,
        rawData3.data.result,
        rawData4.data.result,
      ]
    );

    const rawDataRaw = rawDataUnProcessed.sort(
      (a, b) => new Date(a.time) - new Date(b.time)
    );

    const rawData = R.map(
      (el) => ({ ...el, ...el.extra_info }),
      rawDataRaw.filter((el) => el.probe_success === 1)
    );

    this.setState(() => ({
      rawData,
    }));
  };

  async componentDidUpdate(prevProps) {
    if (
      this.props.check.data.last_check_at !==
        prevProps.check.data.last_check_at &&
      this.props.check.id === prevProps.check.id
    ) {
      if (this.state.rawDataChartToggle) {
        this.getRawData();
      }
    }

    if (this.props.check.id !== prevProps.check.id) {
      this.setState(() => ({
        rawDataChartToggle: false,
      }));
    }
  }

  render() {
    return (
      <div className="check-detail__container">
        {this.props.check.data &&
          Object.keys(this.props.check.data).length > 4 && (
            <div className="check-detail__left">
              <MonitorHeader
                data={this.props.check}
                activePlanHistoryPeriod={
                  this.props.activePlan
                    ? this.props.activePlan.specifications.METRIC_HISTORY_DAYS
                    : undefined
                }
                activePlanName={
                  this.props.activePlan ? this.props.activePlan.name : undefined
                }
                isShare={this.props.isShare ? this.props.isShare : false}
              />

              <div className="section">
                <UptimeTimeline
                  uptime={
                    this.props.check.data
                      ? this.props.check.data.uptime_percent
                      : null
                  }
                  downtimes={
                    this.props.check.data ? this.props.check.data.downtimes : []
                  }
                  lastCheckAt={
                    this.props.check.data
                      ? this.props.check.data.last_check_at
                      : null
                  }
                  firstCheckAt={
                    this.props.check.data
                      ? this.props.check.data.first_check_at
                      : null
                  }
                />
                {this.state.toggle === true ? (
                  <UptimeTable
                    downtimes={
                      this.props.check.data
                        ? this.props.check.data.downtimes
                        : []
                    }
                  />
                ) : undefined}
                {this.props.check.data ? (
                  !R.isEmpty(this.props.check.data.downtimes) ? (
                    <Button
                      className="more"
                      onClick={this.toggle}
                      type="primary"
                      icon={
                        this.state.toggle === false ? (
                          <ArrowDownOutlined />
                        ) : (
                          <ArrowUpOutlined />
                        )
                      }
                      size="small"
                    >
                      {`Show ${this.state.toggle === false ? "more" : "less"}`}
                    </Button>
                  ) : undefined
                ) : undefined}
              </div>
              <div className="section">
                <ApdexTimeline
                  datas={
                    this.props.check.data.last_day_hourly_metrics
                      ? this.props.check.data.last_day_hourly_metrics
                          .apdex_percents
                      : []
                  }
                  apdex={this.props.check.apdex}
                  finalApdex={this.props.check.data.apdex_percent}
                  isToday={moment(this.props.check.data.last_check_at).isSame(
                    moment(),
                    "day"
                  )}
                />
              </div>
              <div className="section">
                <RTChart
                  datas={dataRTChart(
                    this.props.check.data.by_response_time
                      ? this.props.check.data.by_response_time
                      : []
                  )}
                  sum={
                    this.props.check.data.by_response_time.under100000 +
                    this.props.check.data.by_response_time.error
                  }
                  apdex={this.props.check.apdex}
                  avg={
                    this.props.check.data.by_response_time.average_response_time
                  }
                />

                {/* <Button
                  className="more"
                  onClick={this.toggleRawData}
                  type="primary"
                  icon={
                    this.state.rawDataChartToggle === false ? (
                      <ArrowDownOutlined />
                    ) : (
                      <ArrowUpOutlined />
                    )
                  }
                  size="small"
                >
                  {`Show ${
                    this.state.rawDataChartToggle === false ? "more" : "less"
                  }`}
                </Button> */}

                {this.state.rawDataChartToggle && this.state.rawData ? (
                  <RPTChart data={this.state.rawData} />
                ) : undefined}
              </div>
              <div className="section">
                <ProbersChart
                  data={
                    this.props.check.data.probers
                      ? this.props.check.data.probers
                      : []
                  }
                  protoType={this.props.check.protocol_type}
                />
              </div>
              <div className="section">
                <MonthlyHitMap
                  data={
                    this.props.check.data.monthly_metrics
                      ? this.props.check.data.monthly_metrics
                      : {}
                  }
                  checkId={this.props.check.id}
                  activePlanHistoryPeriod={
                    this.props.activePlan
                      ? this.props.activePlan.specifications.METRIC_HISTORY_DAYS
                      : undefined
                  }
                  activePlanName={
                    this.props.activePlan
                      ? this.props.activePlan.name
                      : undefined
                  }
                  onDateClicked={this.props.startGetMonitorHistory}
                  isShare={this.props.isShare ? this.props.isShare : false}
                />
              </div>
            </div>
          )}
        {!this.props.check.data && (
          <div className="monitoring-check-container">
            <Loader />
            <h5 className="monitoring-check-desc">
              {`Updamus is monitoring ${this.props.check.target}`}
              <br />
              It may take a few minutes, thank you for your patience.
            </h5>
          </div>
        )}
      </div>
    );
  }
}

const dataRTChart = (datas) => {
  const error = datas.error;
  let rtData = Object.keys(datas).map((key) => datas[key]);
  rtData = rtData.slice(0, rtData.length - 2);
  let temp = 0;
  let elment;
  let finalData = rtData.map((el) => {
    elment = el - temp;
    temp = el;
    return elment;
  });
  finalData.push(error);
  return finalData;
};

const mapStateToProps = (state, props) => {
  return {
    check: state.checks.find((check) => check.id.toString() === props.id),
    activePlan: state.plans.subscriptions
      ? state.plans.subscriptions[0].subscription_plan
      : undefined,
    token: state.auth.uid,
  };
};

const mapDispatchToProps = (dispatch) => ({
  startGetMonitorHistory: (id, date) =>
    dispatch(startGetMonitorHistory(id, date)),
  startRefresh: (id, isRefresh) => dispatch(startRefresh(id, isRefresh)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckDetail);
